import './sparkleBurst.css'

import { Sparkles } from 'lucide-react'

import { cn } from '@/lib/utils'
import caiCharacter from './caiCharacter.webp'

/** All down one column, trailing each other — a row plus a delay is a diagonal. */
const SPARKLES = [0, 1, 2, 3, 4]

/** Far enough up to clear the page: they fall in from above the conversation. */
const FALL_FROM = '-380px'

/**
 * Cai sitting in the corner, taking in what was just answered. The sparkles
 * run for as long as there is work behind them; the swell is keyed on the
 * send count, since remounting is what replays a one-shot animation.
 */
export function LearningCharacter({ sent, working }: { sent: number; working: boolean }) {
  return (
    <div className="pointer-events-none absolute right-2 bottom-0 w-44 select-none">
      {working && (
        <span aria-hidden className="absolute inset-x-0 top-[14%]">
          {SPARKLES.map((index) => (
            // Centring lives on the wrapper: the keyframe owns the icon's
            // transform, so a translate class on the icon is overwritten.
            <span key={index} className="absolute left-1/2 -translate-x-1/2">
              <Sparkles
                className="cai-sparkle text-brand size-5 fill-current"
                style={
                  {
                    '--cai-from': FALL_FROM,
                    animationDelay: `${index * 280}ms`,
                  } as React.CSSProperties
                }
              />
            </span>
          ))}
        </span>
      )}
      <img key={sent} src={caiCharacter} alt="" className={cn('w-full', sent > 0 && 'cai-learn')} />
    </div>
  )
}
